import React, {useEffect, useRef, useState} from "react";
import ReactModal from "react-modal";
import {PiX} from "react-icons/pi";
import {
    useCreateDowntimeActMutation,
    useSearchDowntimeActJournalPageQuery,
    useUpdateDowntimeActMutation
} from "../../../../store/backend-api/backend.api";
import {DowntimeActDescription} from "./downtime-act-description/DowntimeActDescription";
import {Button} from "../../../ui/buttons/Button";
import {DowntimeAct} from "../../../../model/downtime-act/DowntimeAct";

interface Props {
    onModalClose: () => void;
    productionTaskDocumentNumber: number | null;
}

export const ProductionTaskDowntimeActModal = ({onModalClose, productionTaskDocumentNumber}: Props) => {
    const [editableDowntimeActNumber, setEditableDowntimeActNumber] = useState<number>(-1);
    const [editableDowntimeActDescription, setEditableDowntimeActDescription] = useState<string>('');
    const ref = useRef<HTMLTextAreaElement>(null);
    const {
        data,
        isSuccess
    } = useSearchDowntimeActJournalPageQuery({productionTaskDocumentNumber: [productionTaskDocumentNumber!]});
    const [doCreateDowntimeAct] = useCreateDowntimeActMutation();
    const [doUpdateDowntimeAct] = useUpdateDowntimeActMutation();

    ReactModal.defaultStyles = {
        overlay: {
            ...ReactModal.defaultStyles.overlay,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            zIndex: 100,
        },
        content: {
            border: '1px solid #ccc',
            background: '#fff',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
            padding: '20px',
            maxHeight: "90%",
            overflowX: 'auto',
            overflowY: 'auto',
        }
    }

    const onClickSaveButton = () => {
        if (editableDowntimeActNumber === -1) {
            doCreateDowntimeAct({
                productionTaskDocumentNumber: productionTaskDocumentNumber!,
                description: editableDowntimeActDescription,
            });
            setEditableDowntimeActDescription('');
            return;
        }
        doUpdateDowntimeAct({number: editableDowntimeActNumber, body: {description: editableDowntimeActDescription}});
        setEditableDowntimeActNumber(-1);
        setEditableDowntimeActDescription('');
    };

    if (!isSuccess) {
        return null
    }

    return (
        <ReactModal isOpen={typeof productionTaskDocumentNumber === 'number'}
                    onRequestClose={onModalClose}>
            <div className="flex flex-row justify-between">
                <p className="font-light text-base -mt-1">Причина простоя</p>
                <button type={"button"}
                        title="Закрыть"
                        onClick={onModalClose}
                        className="-mr-1 -mt-2 text-black/[.30] rounded-[5px]">
                    <PiX className="h-5 w-5"/>
                </button>
            </div>
            <div className='flex flex-col gap-y-1.5 text-sm font-light mt-2'>
                {data!.rows.map((act) =>
                    <DowntimeActDescription downtimeAct={act}
                                            isEditableDowntimeAct={editableDowntimeActNumber === act.documentNumber}
                                            setEditableDowntimeAct={(act: DowntimeAct) => {
                                                setEditableDowntimeActNumber(act.documentNumber);
                                                setEditableDowntimeActDescription(act.description)
                                                ref.current?.focus();
                                            }}/>)}
                <div className='flex flex-col border-[1px] border-gray-400/[.60] rounded mt-2.5'>
                    <div className='flex justify-between p-1.5 border-b-[1px] border-gray-400/[.60]'>
                        {editableDowntimeActNumber === -1 ? 'Создание акта простоя' : `Редактирование №${editableDowntimeActNumber}`}
                        <div className='flex gap-x-2'>
                            {editableDowntimeActNumber !== -1 &&
                                <Button buttonName={"Отменить"} onClickButton={() => {
                                    setEditableDowntimeActNumber(-1);
                                    setEditableDowntimeActDescription('');
                                }}/>}
                            <Button buttonName={"Сохранить"} onClickButton={onClickSaveButton}/>
                        </div>
                    </div>
                    <textarea ref={ref} value={editableDowntimeActDescription} autoFocus
                              onChange={(event) => {
                                  setEditableDowntimeActDescription(event.target.value);
                              }} className='w-[460px] p-1 rounded' rows={3} placeholder='Введите текст'/>
                </div>
            </div>
        </ReactModal>
    );
};